import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { SupportedLanguage } from '@app/i18n/languages';

type LanguageBoundaryProps = PropsWithChildren<{
  language: SupportedLanguage;
}>;

export const LanguageBoundary = ({ language, children }: LanguageBoundaryProps) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== language) {
      void i18n.changeLanguage(language);
    }

    document.documentElement.lang = language;
    document
      .querySelector('link[rel="canonical"]')
      ?.setAttribute('href', `${window.location.origin}/${language}`);
  }, [i18n, language]);

  return children;
};
